export default "__VITE_ASSET__a64eaa61__"